import styled, { css } from 'styled-components';

import { colors } from 'global/colors';

export const PixiAndMatchListContainer = styled.div`
  padding: 50px 0 50px 0;
  @media (max-width: 768px) {
    width: 100%;
  }
  @media (max-width: 768px) {
    padding: 25px 0 25px 0;
  }
`;

export const MatchListContainer = styled.div``;

export const MatchTable = styled.div`
  display: flex;
`;

export const TableTitle = styled.div`
  display: flex;
  justify-content: ${(props) => (props.makeLeft ? `flex-start` : `center`)};
  align-items: center;
  padding: 15px;

  ${(props) =>
    props.isHead &&
    css`
      font-weight: 600;
    `};
`;

export const TableRow = styled.div`
  display: flex;

  ${(props) => css`
    background-color: ${props.isGrey ? colors.lightGray : colors.white};
  `};
`;

export const PlayerContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
`;

export const PlayerBackground = styled.div`
  border-radius: 5px 5px 0px 0px;
  background: ${colors.white};
`;

export const NoMatchesFoundContainer = styled.div`
  justify-content: center;
  display: flex;
  padding-top: 50px;
  font-size: 20px;
`;

export const InputBox = styled.input`
  margin-top: 25px;
`;
